import { sendGet, type Response } from '../hooks/use-fetch'
import { type ImplementationSummary } from '../models/ImplementationSummary'
import { type ImplementationTimeSpan } from '../models/ImplementationTimeSpan'

export async function GetImplementationTimeSpans (): Promise<Response<ImplementationTimeSpan[]>> {
  return await sendGet('Implementation/GetTimeSpans')
}

export async function GetImplementationSummary (timeSpanId: string): Promise<Response<ImplementationSummary>> {
  return await sendGet(`Implementation/GetSummary?timeSpanId=${timeSpanId}`)
}

export async function GetTimeSpan (timeSpanId: string): Promise<Response<ImplementationTimeSpan>> {
  return await sendGet(`Implementation/GetTimeSpan?timeSpanId=${timeSpanId}`)
}
